/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import '../../../common/time';
import '../../../items/items';
import '../../../riskevaluation/external/external';
import '../../../omg/fulfillment/fulfillment';
import '../../v4/fulfillment';
import '../../translation_types';
import '../../../common/colors';
import '../../../connect/v2/common/measurement_units';
import '../../v3/reporting_params';
import '../../v3/bill';
import '../models/payment';
import '../../../omg/model/orders';
import '../../../channels/channels';
import '../../../../google/protobuf/field_mask';
import './request';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "Aggregate": {
                        "fields": {
                          "sales": {
                            "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details",
                            "id": 1,
                            "rule": "optional"
                          },
                          "refunds": {
                            "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details",
                            "id": 2,
                            "rule": "optional"
                          },
                          "net": {
                            "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Details": {
                            "fields": {
                              "transactionCount": {
                                "type": "int64",
                                "id": 1,
                                "rule": "optional"
                              },
                              "discountMoney": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "discountCount": {
                                "type": "int64",
                                "id": 3,
                                "rule": "optional"
                              },
                              "modifierMoney": {
                                "type": ".squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "modifierCount": {
                                "type": "int64",
                                "id": 5,
                                "rule": "optional"
                              },
                              "modifierQuantity": {
                                "type": "string",
                                "id": 27,
                                "rule": "optional",
                                "options": {
                                  "default": "0"
                                }
                              },
                              "grossSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 6,
                                "rule": "optional"
                              },
                              "itemGrossSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 38,
                                "rule": "optional"
                              },
                              "productSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 31,
                                "rule": "optional"
                              },
                              "processingFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 7,
                                "rule": "optional"
                              },
                              "tipMoney": {
                                "type": ".squareup.common.Money",
                                "id": 8,
                                "rule": "optional"
                              },
                              "taxMoney": {
                                "type": ".squareup.common.Money",
                                "id": 9,
                                "rule": "optional"
                              },
                              "tenderTaxMoney": {
                                "type": ".squareup.common.Money",
                                "id": 32,
                                "rule": "optional"
                              },
                              "itemQuantity": {
                                "type": "string",
                                "id": 10,
                                "rule": "optional",
                                "options": {
                                  "default": "0"
                                }
                              },
                              "itemCount": {
                                "type": "string",
                                "id": 44,
                                "rule": "optional",
                                "options": {
                                  "default": "0"
                                }
                              },
                              "netSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 11,
                                "rule": "optional"
                              },
                              "itemNetSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 39,
                                "rule": "optional"
                              },
                              "taxableNetSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 45,
                                "rule": "optional"
                              },
                              "taxableItemNetSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 46,
                                "rule": "optional"
                              },
                              "totalCollectedMoney": {
                                "type": ".squareup.common.Money",
                                "id": 12,
                                "rule": "optional"
                              },
                              "netTotalMoney": {
                                "type": ".squareup.common.Money",
                                "id": 13,
                                "rule": "optional"
                              },
                              "creditMoney": {
                                "type": ".squareup.common.Money",
                                "id": 14,
                                "rule": "optional"
                              },
                              "swedishRoundingMoney": {
                                "type": ".squareup.common.Money",
                                "id": 15,
                                "rule": "optional"
                              },
                              "giftCardNetSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 16,
                                "rule": "optional"
                              },
                              "giftCardLoadMoney": {
                                "type": ".squareup.common.Money",
                                "id": 17,
                                "rule": "optional"
                              },
                              "averageGrossSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 18,
                                "rule": "optional"
                              },
                              "giftCardLoadCount": {
                                "type": "int64",
                                "id": 19,
                                "rule": "optional"
                              },
                              "giftCardsDiscountedCount": {
                                "type": "int64",
                                "id": 33,
                                "rule": "optional"
                              },
                              "giftCardsDiscountedAmount": {
                                "type": ".squareup.common.Money",
                                "id": 34,
                                "rule": "optional"
                              },
                              "australianGrossSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 21,
                                "rule": "optional"
                              },
                              "averageAustralianGrossSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 22,
                                "rule": "optional"
                              },
                              "itemsTaxedCount": {
                                "type": "string",
                                "id": 23,
                                "rule": "optional",
                                "options": {
                                  "default": "0"
                                }
                              },
                              "itemsDiscountedCount": {
                                "type": "string",
                                "id": 24,
                                "rule": "optional",
                                "options": {
                                  "default": "0"
                                }
                              },
                              "itemsModifiedCount": {
                                "type": "string",
                                "id": 25,
                                "rule": "optional",
                                "options": {
                                  "default": "0"
                                }
                              },
                              "processingFeeAmounts": {
                                "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts",
                                "id": 26,
                                "rule": "optional"
                              },
                              "fifoCostOfGoodsAmounts": {
                                "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.CostOfGoodsAmounts",
                                "id": 28,
                                "rule": "optional"
                              },
                              "lifoCostOfGoodsAmounts": {
                                "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.CostOfGoodsAmounts",
                                "id": 29,
                                "rule": "optional"
                              },
                              "averageCostOfGoodsAmounts": {
                                "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.CostOfGoodsAmounts",
                                "id": 30,
                                "rule": "optional"
                              },
                              "surchargeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 35,
                                "rule": "optional"
                              },
                              "autoGratuityMoney": {
                                "type": ".squareup.common.Money",
                                "id": 36,
                                "rule": "optional"
                              },
                              "coverCount": {
                                "type": "int64",
                                "id": 37,
                                "rule": "optional"
                              },
                              "surchargeCount": {
                                "type": "int64",
                                "id": 40,
                                "rule": "optional"
                              },
                              "tenderCount": {
                                "type": "int64",
                                "id": 41,
                                "rule": "optional"
                              },
                              "refundCount": {
                                "type": "int64",
                                "id": 42,
                                "rule": "optional"
                              },
                              "totalSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 43,
                                "rule": "optional"
                              },
                              "measuredQuantity": {
                                "type": ".squareup.beemo.api.v2.reporting.MeasuredQuantity",
                                "id": 47,
                                "rule": "repeated"
                              },
                              "commissionMoney": {
                                "type": ".squareup.common.Money",
                                "id": 48,
                                "rule": "optional"
                              },
                              "itemCommissionMoney": {
                                "type": ".squareup.common.Money",
                                "id": 49,
                                "rule": "optional"
                              },
                              "serviceCommissionMoney": {
                                "type": ".squareup.common.Money",
                                "id": 50,
                                "rule": "optional"
                              },
                              "averageTotalSalesMoney": {
                                "type": ".squareup.common.Money",
                                "id": 51,
                                "rule": "optional"
                              },
                              "mostRecentOccurredAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 52,
                                "rule": "optional"
                              },
                              "deductedServiceCostMoney": {
                                "type": ".squareup.common.Money",
                                "id": 53,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "ProcessingFeeAmounts": {
                                "fields": {
                                  "squareProcessingFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "taxOnProcessingFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "thirdPartyFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "squareProcessingFeeAmountDetails": {
                                    "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "thirdPartyFeeAmountDetails": {
                                    "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail",
                                    "id": 4,
                                    "rule": "repeated"
                                  }
                                },
                                "nested": {
                                  "SquareProcessingFeeAmountDetails": {
                                    "fields": {
                                      "initialFeeMoney": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "initialTaxOnFeeMoney": {
                                        "type": ".squareup.common.Money",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "adjustmentFeeMoney": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "adjustmentTaxOnFeeMoney": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "freeProcessingFeeMoney": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "ThirdPartyFeeAmountDetail": {
                                    "fields": {
                                      "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "thirdPartyFeeEntity": {
                                        "type": ".squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeEntity",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "ThirdPartyFeeEntity": {
                                    "fields": {
                                      "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "displayName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "unitName": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              },
                              "CostOfGoodsAmounts": {
                                "fields": {
                                  "totalCostMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "averageCostMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "totalProfitMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "totalRevenueMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "averageRevenueMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "profitMargin": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "cogsItemsCount": {
                                    "type": "string",
                                    "id": 7,
                                    "rule": "optional",
                                    "options": {
                                      "default": "0"
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "GroupByType": {
                        "values": {
                          "NONE": 1,
                          "BILL_TOKEN": 81,
                          "DISCOUNT": 2,
                          "ITEM_CATEGORY": 3,
                          "EMPLOYEE": 4,
                          "ACTING_EMPLOYEE": 56,
                          "EMPLOYEE_ROLE": 40,
                          "EMPLOYEE_JOB": 84,
                          "DEVICE": 5,
                          "ITEM": 6,
                          "ITEM_TYPE": 82,
                          "ITEM_VARIATION": 7,
                          "MOBILE_STAFF": 8,
                          "SUBUNIT": 9,
                          "MODIFIER": 10,
                          "PAYMENT_METHOD": 11,
                          "MODIFIER_SET": 12,
                          "DEVICE_NAME": 13,
                          "DEVICE_TOKEN": 14,
                          "HOUR": 15,
                          "TIME_WINDOW": 16,
                          "UNIT_PRICE": 17,
                          "PAYMENT_METHOD_SEPARATED": 18,
                          "TAX_NAME": 19,
                          "DAY": 20,
                          "MONTH": 21,
                          "FEE_TYPE": 22,
                          "PRODUCT": 23,
                          "TAXABLE": 24,
                          "DAY_OF_WEEK": 25,
                          "HOUR_OF_DAY": 26,
                          "WEEK": 27,
                          "DINING_OPTION": 28,
                          "GIFT_CARD_ITEM": 29,
                          "GIFT_CARD_ACTIVITY_TYPE": 30,
                          "GIFT_CARD_TENDER": 31,
                          "PAN_SUFFIX": 32,
                          "VIRTUAL_REGISTER_TOKEN": 33,
                          "BUSINESS_DAY_TOKEN": 34,
                          "ACTIVITY_TYPE": 35,
                          "VOID_REASON": 36,
                          "EVENT_TYPE": 37,
                          "DISCOUNT_ADJUSTMENT_TYPE": 38,
                          "COMP_REASON": 39,
                          "UNIQUE_ITEMIZATION": 41,
                          "TICKET_GROUP": 42,
                          "DEVICE_CREDENTIAL": 43,
                          "LAST_ITEMIZATION_UPDATE_EMPLOYEE_TOKEN": 44,
                          "ITEMIZATION_NOTE": 45,
                          "RECEIPT_NUMBER": 46,
                          "TICKET_NAME": 47,
                          "DEVICE_CREDENTIAL_NAME": 48,
                          "TOTAL_COLLECTED_AMOUNT": 49,
                          "CONVERSATIONAL_MODE": 50,
                          "BILL_NOTE": 51,
                          "TENDER_NOTE": 52,
                          "MENU_NAME": 53,
                          "FEE_PLAN": 54,
                          "FEE_PLAN_TYPE": 55,
                          "TICKET_TEMPLATE": 57,
                          "RESTAURANT_COVER": 58,
                          "PAYMENT_SOURCE_NAME": 59,
                          "ITEMIZATION_TYPE": 60,
                          "SURCHARGE_TYPE": 61,
                          "CONTACT_TOKEN": 62,
                          "SURCHARGE_NAME": 63,
                          "ORDER_SOURCE_NAME": 64,
                          "RISK_EVALUATION_LEVEL": 65,
                          "RISK_EVALUATION_ACTION": 74,
                          "RISK_EVALUATION_RULE": 75,
                          "ITEM_VARIATION_MEASUREMENT_UNIT": 66,
                          "ORDER_DISPLAY_NAME": 67,
                          "FULFILLMENT_TYPE": 68,
                          "FULFILLMENT_STATE": 69,
                          "FULFILLMENT_RECIPIENT_NAME": 70,
                          "FULFILLMENT_RECIPIENT_PHONE": 71,
                          "FULFILLMENT_RECIPIENT_EMAIL": 72,
                          "VENDOR": 73,
                          "ATTRIBUTED_EMPLOYEE": 77,
                          "MINUTE": 78,
                          "HOUSE_ACCOUNT_INVOICE": 79,
                          "FREE_PROCESSING": 80,
                          "CHANNEL_ATTRIBUTION": 83
                        }
                      },
                      "GroupByValue": {
                        "fields": {
                          "transactionCompletedAtMs": {
                            "type": "int64",
                            "id": 47,
                            "rule": "optional"
                          },
                          "billToken": {
                            "type": "string",
                            "id": 71,
                            "rule": "optional"
                          },
                          "discount": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Discount",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemCategory": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemCategory",
                            "id": 2,
                            "rule": "optional"
                          },
                          "employee": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Employee",
                            "id": 3,
                            "rule": "optional"
                          },
                          "actingEmployee": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Employee",
                            "id": 50,
                            "rule": "optional"
                          },
                          "employeeRole": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.EmployeeRole",
                            "id": 35,
                            "rule": "optional"
                          },
                          "employeeJob": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.EmployeeJob",
                            "id": 73,
                            "rule": "optional"
                          },
                          "device": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Device",
                            "id": 4,
                            "rule": "optional"
                          },
                          "item": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Item",
                            "id": 5,
                            "rule": "optional"
                          },
                          "itemType": {
                            "type": ".squareup.api.items.Item.Type",
                            "id": 67,
                            "rule": "optional"
                          },
                          "itemVariation": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemVariation",
                            "id": 6,
                            "rule": "optional"
                          },
                          "mobileStaff": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.MobileStaff",
                            "id": 7,
                            "rule": "optional"
                          },
                          "subunit": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Subunit",
                            "id": 8,
                            "rule": "optional"
                          },
                          "modifier": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Modifier",
                            "id": 9,
                            "rule": "optional"
                          },
                          "paymentMethod": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.PaymentMethod",
                            "id": 10,
                            "rule": "optional"
                          },
                          "modifierSet": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ModifierSet",
                            "id": 11,
                            "rule": "optional"
                          },
                          "hour": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TimeRange",
                            "id": 12,
                            "rule": "optional"
                          },
                          "timeWindow": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TimeRange",
                            "id": 13,
                            "rule": "optional"
                          },
                          "unitPrice": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.UnitPrice",
                            "id": 14,
                            "rule": "optional"
                          },
                          "tax": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Tax",
                            "id": 15,
                            "rule": "optional"
                          },
                          "day": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TimeRange",
                            "id": 16,
                            "rule": "optional"
                          },
                          "month": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TimeRange",
                            "id": 17,
                            "rule": "optional"
                          },
                          "feeType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.FeeType",
                            "id": 18,
                            "rule": "optional"
                          },
                          "product": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Product",
                            "id": 19,
                            "rule": "optional"
                          },
                          "taxable": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Taxable",
                            "id": 20,
                            "rule": "optional"
                          },
                          "dayOfWeek": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DayOfWeek",
                            "id": 21,
                            "rule": "optional"
                          },
                          "hourOfDay": {
                            "type": "int32",
                            "id": 22,
                            "rule": "optional"
                          },
                          "week": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TimeRange",
                            "id": 23,
                            "rule": "optional"
                          },
                          "diningOption": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DiningOption",
                            "id": 24,
                            "rule": "optional"
                          },
                          "giftCard": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.GiftCard",
                            "id": 25,
                            "rule": "optional"
                          },
                          "giftCardActivityType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.GiftCardActivityType",
                            "id": 26,
                            "rule": "optional"
                          },
                          "cardDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.CardDetails",
                            "id": 27,
                            "rule": "optional"
                          },
                          "virtualRegisterDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.VirtualRegisterDetails",
                            "id": 28,
                            "rule": "optional"
                          },
                          "businessDayDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.BusinessDayDetails",
                            "id": 29,
                            "rule": "optional"
                          },
                          "activityTypeDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ActivityTypeDetails",
                            "id": 30,
                            "rule": "optional"
                          },
                          "voidReason": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.VoidReason",
                            "id": 31,
                            "rule": "optional"
                          },
                          "eventTypeDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.EventTypeDetails",
                            "id": 32,
                            "rule": "optional"
                          },
                          "discountAdjustmentTypeDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DiscountAdjustmentTypeDetails",
                            "id": 33,
                            "rule": "optional"
                          },
                          "compReason": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.CompReason",
                            "id": 34,
                            "rule": "optional"
                          },
                          "uniqueItemization": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.UniqueItemization",
                            "id": 36,
                            "rule": "optional"
                          },
                          "ticketGroup": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TicketGroup",
                            "id": 37,
                            "rule": "optional"
                          },
                          "deviceCredential": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DeviceCredential",
                            "id": 38,
                            "rule": "optional"
                          },
                          "itemizationNote": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemizationNote",
                            "id": 39,
                            "rule": "optional"
                          },
                          "receiptDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ReceiptDetails",
                            "id": 40,
                            "rule": "optional"
                          },
                          "ticketName": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TicketName",
                            "id": 41,
                            "rule": "optional"
                          },
                          "transactionTotal": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TransactionTotal",
                            "id": 42,
                            "rule": "optional"
                          },
                          "conversationalMode": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ConversationalMode",
                            "id": 43,
                            "rule": "optional"
                          },
                          "billNote": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.BillNote",
                            "id": 44,
                            "rule": "optional"
                          },
                          "tenderNote": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TenderNote",
                            "id": 45,
                            "rule": "optional"
                          },
                          "menu": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Menu",
                            "id": 46,
                            "rule": "optional"
                          },
                          "feePlan": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.FeePlan",
                            "id": 48,
                            "rule": "optional"
                          },
                          "feePlanTypeDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.FeePlanTypeDetails",
                            "id": 49,
                            "rule": "optional"
                          },
                          "ticketTemplate": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TicketTemplate",
                            "id": 51,
                            "rule": "optional"
                          },
                          "restaurantCoverDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.RestaurantCoverDetails",
                            "id": 52,
                            "rule": "optional"
                          },
                          "paymentSourceName": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.PaymentSourceName",
                            "id": 53,
                            "rule": "optional"
                          },
                          "itemizationTypeDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemizationTypeDetails",
                            "id": 54,
                            "rule": "optional"
                          },
                          "surchargeTypeDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.SurchargeTypeDetails",
                            "id": 55,
                            "rule": "optional"
                          },
                          "contactDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ContactDetails",
                            "id": 56,
                            "rule": "optional"
                          },
                          "surchargeNameDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.SurchargeNameDetails",
                            "id": 57,
                            "rule": "optional"
                          },
                          "orderSourceName": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.OrderSourceName",
                            "id": 58,
                            "rule": "optional"
                          },
                          "riskEvaluationLevel": {
                            "type": ".squareup.riskevaluation.external.Level",
                            "id": 59,
                            "rule": "optional"
                          },
                          "riskEvaluationAction": {
                            "type": ".squareup.riskevaluation.external.Action",
                            "id": 65,
                            "rule": "optional"
                          },
                          "riskEvaluationRule": {
                            "type": "string",
                            "id": 66,
                            "rule": "optional"
                          },
                          "orderDisplayName": {
                            "type": "string",
                            "id": 60,
                            "rule": "optional"
                          },
                          "fulfillmentType": {
                            "type": ".squareup.omg.fulfillment.FulfillmentType",
                            "id": 61,
                            "rule": "optional"
                          },
                          "fulfillmentState": {
                            "type": ".squareup.omg.fulfillment.Fulfillment.State",
                            "id": 62,
                            "rule": "optional"
                          },
                          "fulfillmentRecipient": {
                            "type": ".squareup.beemo.api.v4.FulfillmentRecipient",
                            "id": 63,
                            "rule": "optional"
                          },
                          "vendor": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Vendor",
                            "id": 64,
                            "rule": "optional"
                          },
                          "minute": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TimeRange",
                            "id": 68,
                            "rule": "optional"
                          },
                          "houseAccountInvoice": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.HouseAccountInvoice",
                            "id": 69,
                            "rule": "optional"
                          },
                          "freeProcessing": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.FreeProcessing",
                            "id": 70,
                            "rule": "optional"
                          },
                          "channelAttribution": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ChannelAttribution",
                            "id": 72,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Discount": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "discountAdjustmentType": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DiscountAdjustmentType",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "ItemCategory": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "Employee": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "employeeToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "EmployeeRole": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "employeeRoleToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "EmployeeJob": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "employeeJobToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Device": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "deviceToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Item": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "imageUrl": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "iconColor": {
                                "type": ".squareup.common.RGBAColor",
                                "id": 3,
                                "rule": "optional"
                              },
                              "abbreviation": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "ItemVariation": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "sku": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "gtin": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "definedMeasurementUnit": {
                                "type": ".squareup.connect.v2.common.MeasurementUnit",
                                "id": 3
                              },
                              "defaultMeasurementUnit": {
                                "type": ".squareup.beemo.translation_types.TranslationType",
                                "id": 4
                              }
                            },
                            "nested": {
                              "measurement_unit": {
                                "oneof": ["definedMeasurementUnit", "defaultMeasurementUnit"]
                              }
                            }
                          },
                          "MobileStaff": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "mobileStaffId": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "userToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "Subunit": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "subunitToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Modifier": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "modifierSetName": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 2,
                                "rule": "optional"
                              },
                              "conversationalMode": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "PaymentMethod": {
                            "values": {
                              "CASH": 0,
                              "CREDIT": 1,
                              "OTHER": 2,
                              "SPLIT_TENDER": 3,
                              "THIRD_PARTY_CARD": 4,
                              "SQUARE_GIFT_CARD_V2": 5,
                              "ZERO_AMOUNT": 6,
                              "EXTERNAL": 7,
                              "INSTALLMENT": 8,
                              "EMONEY": 9,
                              "CASH_APP": 10,
                              "BANK_TRANSFER": 11,
                              "MEAL_VOUCHER": 12,
                              "AFTERPAY": 13,
                              "PAYPAY": 14,
                              "OPEN_TICKET": 15,
                              "HOUSE_ACCOUNT": 16,
                              "ALIPAY": 17,
                              "RAKUTEN_PAY": 18,
                              "AU_PAY": 19,
                              "D_BARAI": 20,
                              "MERPAY": 21,
                              "WECHAT_PAY": 22,
                              "VENMO": 23,
                              "BITCOIN": 24,
                              "SNAP": 25,
                              "EBT_CASH": 26
                            }
                          },
                          "ModifierSet": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "TimeRange": {
                            "fields": {
                              "beginTime": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 1,
                                "rule": "optional"
                              },
                              "endTime": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 2,
                                "rule": "optional"
                              },
                              "tzName": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "UnitPrice": {
                            "fields": {
                              "unitPrice": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "Tax": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "FeeType": {
                            "values": {
                              "SWIPED": 1,
                              "KEYED": 2,
                              "DEFAULT": 3,
                              "NO_FEE": 4,
                              "TAPPED": 5,
                              "DIPPED": 6,
                              "ON_FILE": 7,
                              "QR_CODE": 8,
                              "REDIRECT": 9,
                              "SMS": 10
                            }
                          },
                          "Product": {
                            "values": {
                              "DEFAULT_PRODUCT": 0,
                              "REGISTER": 1,
                              "MARKET": 2,
                              "ORDER": 3,
                              "EXTERNAL_API": 4,
                              "APPOINTMENTS": 5,
                              "INVOICES": 6,
                              "EGIFTING": 7
                            }
                          },
                          "Taxable": {
                            "values": {
                              "TAXABLE": 1,
                              "NON_TAXABLE": 2
                            }
                          },
                          "DayOfWeek": {
                            "values": {
                              "SUNDAY": 0,
                              "MONDAY": 1,
                              "TUESDAY": 2,
                              "WEDNESDAY": 3,
                              "THURSDAY": 4,
                              "FRIDAY": 5,
                              "SATURDAY": 6
                            }
                          },
                          "DiningOption": {
                            "fields": {
                              "diningOptionId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "GiftCard": {
                            "fields": {
                              "tokenOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "GiftCardActivityType": {
                            "values": {
                              "NO_ACTIVITY": 0,
                              "ACTIVATION": 1,
                              "RELOAD": 2,
                              "UNACTIVATED_SALE": 3
                            }
                          },
                          "CardDetails": {
                            "fields": {
                              "panSuffix": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "VirtualRegisterDetails": {
                            "fields": {
                              "virtualRegisterToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "BusinessDayDetails": {
                            "fields": {
                              "businessDayToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "ActivityTypeDetails": {
                            "fields": {
                              "activityType": {
                                "type": ".squareup.beemo.itemizations.api.v3.ActivityType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "VoidReason": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "EventTypeDetails": {
                            "fields": {
                              "eventType": {
                                "type": ".squareup.beemo.v3.EventType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "DiscountAdjustmentType": {
                            "values": {
                              "DISCOUNT": 0,
                              "REWARD": 1,
                              "COUPON": 2,
                              "COMP": 3,
                              "NO_DISCOUNT_ADJUSTMENT_TYPE": 4,
                              "COMBO": 5
                            }
                          },
                          "DiscountAdjustmentTypeDetails": {
                            "fields": {
                              "discountAdjustmentType": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DiscountAdjustmentType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "CompReason": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "ModifierDetails": {
                            "fields": {
                              "modifier": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Modifier",
                                "id": 1,
                                "rule": "optional"
                              },
                              "singleQuantityAppliedMoney": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "modifierBasePrice": {
                                "type": ".squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "modifierQuantity": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "TaxDetails": {
                            "fields": {
                              "tax": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Tax",
                                "id": 1,
                                "rule": "optional"
                              },
                              "inclusionType": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TaxDetails.InclusionType",
                                "id": 2,
                                "rule": "optional"
                              },
                              "rate": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "InclusionType": {
                                "values": {
                                  "ADDITIVE": 0,
                                  "INCLUSIVE": 1
                                }
                              }
                            }
                          },
                          "DiscountDetails": {
                            "fields": {
                              "discount": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Discount",
                                "id": 1,
                                "rule": "optional"
                              },
                              "type": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DiscountDetails.DiscountBasisType",
                                "id": 2,
                                "rule": "optional"
                              },
                              "rate": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "singleQuantityAppliedMoney": {
                                "type": ".squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "DiscountBasisType": {
                                "values": {
                                  "AMOUNT": 0,
                                  "PERCENTAGE": 1
                                }
                              }
                            }
                          },
                          "UniqueItemization": {
                            "fields": {
                              "itemCategory": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemCategory",
                                "id": 1,
                                "rule": "optional"
                              },
                              "item": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.Item",
                                "id": 2,
                                "rule": "optional"
                              },
                              "itemVariation": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemVariation",
                                "id": 3,
                                "rule": "optional"
                              },
                              "unitPrice": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.UnitPrice",
                                "id": 4,
                                "rule": "optional"
                              },
                              "modifierDetails": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ModifierDetails",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "taxDetails": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.TaxDetails",
                                "id": 6,
                                "rule": "repeated"
                              },
                              "discountDetails": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.DiscountDetails",
                                "id": 7,
                                "rule": "repeated"
                              }
                            }
                          },
                          "TicketGroup": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "DeviceCredential": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "ItemizationNote": {
                            "fields": {
                              "note": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "ReceiptDetails": {
                            "fields": {
                              "receiptNumber": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "TicketName": {
                            "fields": {
                              "ticketName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "TransactionTotal": {
                            "fields": {
                              "totalCollectedMoney": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "ConversationalMode": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "BillNote": {
                            "fields": {
                              "note": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "TenderNote": {
                            "fields": {
                              "note": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "Menu": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "FeePlan": {
                            "fields": {
                              "discountBasisPoints": {
                                "type": "int64",
                                "id": 1,
                                "rule": "optional"
                              },
                              "interchangeCents": {
                                "type": "int64",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "FeePlanTypeDetails": {
                            "fields": {
                              "feePlanType": {
                                "type": ".squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.FeeType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "TicketTemplate": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "RestaurantCoverDetails": {
                            "fields": {
                              "coverType": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.RestaurantCoverDetails.CoverType",
                                "id": 1,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "CoverType": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "COVERED": 1,
                                  "NOT_COVERED": 2
                                }
                              }
                            }
                          },
                          "PaymentSourceName": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "ItemizationTypeDetails": {
                            "fields": {
                              "itemizationType": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ItemizationTypeDetails.ItemizationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "ItemizationType": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "ITEM": 1,
                                  "SURCHARGE": 2
                                }
                              }
                            }
                          },
                          "SurchargeTypeDetails": {
                            "fields": {
                              "surchargeType": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.SurchargeTypeDetails.SurchargeType",
                                "id": 1,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "SurchargeType": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "AUTO_GRATUITY": 1,
                                  "CUSTOM": 2,
                                  "NO_SURCHARGE_TYPE": 3
                                }
                              }
                            }
                          },
                          "ContactDetails": {
                            "fields": {
                              "contactToken": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "SurchargeNameDetails": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "OrderSourceName": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "Vendor": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "token": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "HouseAccountInvoice": {
                            "values": {
                              "HOUSE_ACCOUNT_INVOICE": 1,
                              "NON_HOUSE_ACCOUNT_INVOICE": 2
                            }
                          },
                          "FreeProcessing": {
                            "values": {
                              "FREE_PROCESSING": 1,
                              "NO_FREE_PROCESSING": 2
                            }
                          },
                          "ChannelAttribution": {
                            "fields": {
                              "nameOrTranslationType": {
                                "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                                "id": 3,
                                "rule": "optional"
                              },
                              "channelId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "channelScope": {
                                "type": ".squareup.omg.model.Order.Channel.Scope",
                                "id": 2,
                                "rule": "optional"
                              },
                              "channelType": {
                                "type": ".squareup.omg.model.Order.ChannelAttribution.Type",
                                "id": 4,
                                "rule": "optional"
                              },
                              "channelReference": {
                                "type": ".squareup.beemo.api.v2.reporting.GroupByValue.ChannelReference",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "ChannelReference": {
                            "fields": {
                              "type": {
                                "type": ".squareup.channels.Reference.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "id": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "onlineStoreUrl": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "isOnlineStoreKioskSite": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "CustomReportRequestFlags": {
                        "fields": {
                          "requestTimeoutOverrideSeconds": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "localAggregationReportSizeLimitOverride": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "protoAggregatorReportSizeLimitOverride": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "protoAggregatorBillEventCountLimitOverride": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "spannerScanInfosPerThread": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": 5
                            }
                          },
                          "spannerScanInfoThresholdSize": {
                            "type": "int32",
                            "id": 10,
                            "rule": "optional",
                            "options": {
                              "default": 10
                            }
                          },
                          "spannerMaxFanoutsPerRequest": {
                            "type": "int32",
                            "id": 11,
                            "rule": "optional",
                            "options": {
                              "default": 20
                            }
                          },
                          "spannerMaxThreadsPerRequest": {
                            "type": "int32",
                            "id": 12,
                            "rule": "optional",
                            "options": {
                              "default": 16
                            }
                          },
                          "cacheCustomReport": {
                            "type": "bool",
                            "id": 16,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "spannerMaxScanInfosPerRequest": {
                            "type": "int32",
                            "id": 17,
                            "rule": "optional",
                            "options": {
                              "default": 300
                            }
                          },
                          "spannerMaxCustomReportSizeKb": {
                            "type": "int32",
                            "id": 18,
                            "rule": "optional",
                            "options": {
                              "default": 20000
                            }
                          },
                          "shouldForwardRequest": {
                            "type": "bool",
                            "id": 19,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "reportTypeForForwarding": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "fieldMask": {
                            "type": ".google.protobuf.FieldMask",
                            "id": 21,
                            "rule": "optional"
                          }
                        }
                      },
                      "GroupingType": {
                        "fields": {
                          "groupByType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "reportingGroupConfigId": {
                            "type": "string",
                            "id": 2
                          },
                          "reportingGroupConfigDetails": {
                            "type": ".squareup.beemo.api.v2.reporting.ReportingGroupConfigDetails",
                            "id": 3
                          }
                        },
                        "nested": {
                          "reporting_group_config": {
                            "oneof": ["reportingGroupConfigId", "reportingGroupConfigDetails"]
                          }
                        }
                      },
                      "CustomReportAggregateOptions": {
                        "fields": {
                          "includeGiftCardItemizations": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeBillEventTokens": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeBillTokens": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includePartialPaymentDetails": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "liveDataOptions": {
                            "type": ".squareup.beemo.api.v2.reporting.LiveDataOptions",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "CustomReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "filter": {
                            "type": ".squareup.beemo.api.v2.reporting.Filter",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "requestFlags": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReportRequestFlags",
                            "id": 7,
                            "rule": "optional"
                          },
                          "aggregateOptions": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReportAggregateOptions",
                            "id": 9,
                            "rule": "optional"
                          },
                          "groupingType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupingType",
                            "id": 10,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CustomReport": {
                        "fields": {
                          "groupByType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "aggregate": {
                            "type": ".squareup.beemo.api.v2.reporting.Aggregate",
                            "id": 3,
                            "rule": "optional"
                          },
                          "subReport": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReport",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "groupByValue": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue",
                            "id": 2
                          },
                          "reportingGroupValue": {
                            "type": ".squareup.beemo.api.v2.reporting.ReportingGroupValue",
                            "id": 5
                          }
                        },
                        "nested": {
                          "value": {
                            "oneof": ["groupByValue", "reportingGroupValue"]
                          }
                        }
                      },
                      "CustomReportResponse": {
                        "fields": {
                          "customReport": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReport",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "billEventToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "billToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "salesInsideRangeDetail": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReportResponse.PartialPaymentDetail",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "salesOutsideRangeDetail": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReportResponse.PartialPaymentDetail",
                            "id": 4,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "PartialPaymentDetail": {
                            "fields": {
                              "billToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "totalCollected": {
                                "type": "int64",
                                "id": 2,
                                "rule": "optional"
                              },
                              "insideRangeTotalCollected": {
                                "type": "int64",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ReportingGroupMember": {
                        "fields": {
                          "translationType": {
                            "type": ".squareup.beemo.translation_types.TranslationType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "stringValue": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ReportingGroup": {
                        "fields": {
                          "groupName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "reportingGroupMember": {
                            "type": ".squareup.beemo.api.v2.reporting.ReportingGroupMember",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ReportingGroupConfigDetails": {
                        "fields": {
                          "groupByType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "reportingGroup": {
                            "type": ".squareup.beemo.api.v2.reporting.ReportingGroup",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ReportingGroupValue": {
                        "fields": {
                          "reportingGroupName": {
                            "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "AvailableFiltersRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "filterType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "filter": {
                            "type": ".squareup.beemo.api.v2.reporting.Filter",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "filterTypeV2": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupingType",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "requestFlags": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReportRequestFlags",
                            "id": 5,
                            "rule": "optional"
                          },
                          "aggregateOptions": {
                            "type": ".squareup.beemo.api.v2.reporting.CustomReportAggregateOptions",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "AvailableFiltersResponse": {
                        "fields": {
                          "filter": {
                            "type": ".squareup.beemo.api.v2.reporting.Filter",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "LiveDataOptions": {
                        "fields": {
                          "includeClosedCheckData": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "Filter": {
                        "fields": {
                          "groupByType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByValue": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "filterMode": {
                            "type": ".squareup.beemo.api.v2.reporting.Filter.FilterMode",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": "INCLUDE"
                            }
                          },
                          "groupingType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupingType",
                            "id": 4,
                            "rule": "optional"
                          },
                          "reportingGroupValue": {
                            "type": ".squareup.beemo.api.v2.reporting.ReportingGroupValue",
                            "id": 5,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "FilterMode": {
                            "values": {
                              "INCLUDE": 0,
                              "EXCLUDE": 1
                            }
                          }
                        }
                      },
                      "FilterV2": {
                        "fields": {
                          "anyTerm": {
                            "type": ".squareup.beemo.api.v2.reporting.AnyTerm",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "AnyTerm": {
                        "fields": {
                          "groupByType": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByValue": {
                            "type": ".squareup.beemo.api.v2.reporting.GroupByValue",
                            "id": 2,
                            "rule": "optional"
                          },
                          "matchStrategy": {
                            "type": ".squareup.beemo.api.v2.reporting.AnyTerm.MatchStrategy",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": "EXACT"
                            }
                          },
                          "filterMode": {
                            "type": ".squareup.beemo.api.v2.reporting.AnyTerm.FilterMode",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "INCLUDE"
                            }
                          }
                        },
                        "nested": {
                          "MatchStrategy": {
                            "values": {
                              "EXACT": 0,
                              "PARTIAL": 1
                            }
                          },
                          "FilterMode": {
                            "values": {
                              "UNKNOWN": 0,
                              "INCLUDE": 1,
                              "EXCLUDE": 2
                            }
                          }
                        }
                      },
                      "MeasuredQuantity": {
                        "fields": {
                          "quantity": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "0"
                            }
                          },
                          "definedMeasurementUnit": {
                            "type": ".squareup.connect.v2.common.MeasurementUnit",
                            "id": 2
                          },
                          "defaultMeasurementUnit": {
                            "type": ".squareup.beemo.translation_types.TranslationType",
                            "id": 3,
                            "options": {
                              "default": "DEFAULT_MEASUREMENT_UNIT"
                            }
                          }
                        },
                        "nested": {
                          "measurement_unit": {
                            "oneof": ["definedMeasurementUnit", "defaultMeasurementUnit"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate?.nested?.Details && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate?.nested?.Details?.nested?.ProcessingFeeAmounts && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate?.nested?.Details?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate?.nested?.Details?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate?.nested?.Details?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeEntity && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Aggregate?.nested?.Details?.nested?.CostOfGoodsAmounts && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Discount && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ItemCategory && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Employee && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.EmployeeRole && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.EmployeeJob && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Device && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Item && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ItemVariation && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.MobileStaff && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Subunit && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Modifier && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.PaymentMethod && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ModifierSet && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TimeRange && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.UnitPrice && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Tax && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.FeeType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Product && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Taxable && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DayOfWeek && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DiningOption && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.GiftCard && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.GiftCardActivityType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.CardDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.VirtualRegisterDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.BusinessDayDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ActivityTypeDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.VoidReason && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.EventTypeDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DiscountAdjustmentType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DiscountAdjustmentTypeDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.CompReason && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ModifierDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TaxDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TaxDetails?.nested?.InclusionType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DiscountDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DiscountDetails?.nested?.DiscountBasisType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.UniqueItemization && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TicketGroup && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.DeviceCredential && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ItemizationNote && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ReceiptDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TicketName && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TransactionTotal && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ConversationalMode && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.BillNote && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TenderNote && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Menu && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.FeePlan && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.FeePlanTypeDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.TicketTemplate && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.RestaurantCoverDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.RestaurantCoverDetails?.nested?.CoverType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.PaymentSourceName && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ItemizationTypeDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ItemizationTypeDetails?.nested?.ItemizationType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.SurchargeTypeDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.SurchargeTypeDetails?.nested?.SurchargeType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ContactDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.SurchargeNameDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.OrderSourceName && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.Vendor && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.HouseAccountInvoice && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.FreeProcessing && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ChannelAttribution && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupByValue?.nested?.ChannelReference && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CustomReportRequestFlags && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GroupingType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CustomReportAggregateOptions && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CustomReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CustomReport && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CustomReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CustomReportResponse?.nested?.PartialPaymentDetail && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ReportingGroupMember && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ReportingGroup && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ReportingGroupConfigDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ReportingGroupValue && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.AvailableFiltersRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.AvailableFiltersResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LiveDataOptions && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Filter && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.Filter?.nested?.FilterMode && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.FilterV2 && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.AnyTerm && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.AnyTerm?.nested?.MatchStrategy && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.AnyTerm?.nested?.FilterMode && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.MeasuredQuantity) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Aggregate @ squareup/beemo/v2/reporting/custom_report.proto at 25:1
 */
export const Aggregate = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate');
fixType(Aggregate);
Builder.createAndAttachToType(Aggregate);
/**
 * SOURCE Details @ squareup/beemo/v2/reporting/custom_report.proto at 26:3
 */
Aggregate.Details = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate.Details');
fixType(Aggregate.Details);
Builder.createAndAttachToType(Aggregate.Details);
/**
 * This is the breakdown for processing_fee_money.
 *
 * SOURCE ProcessingFeeAmounts @ squareup/beemo/v2/reporting/custom_report.proto at 162:5
 */
Aggregate.Details.ProcessingFeeAmounts = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts');
fixType(Aggregate.Details.ProcessingFeeAmounts);
Builder.createAndAttachToType(Aggregate.Details.ProcessingFeeAmounts);
/**
 * Additional breakdown of square_processing_fee_money. This is similar to
 * SquareProcessingFeeAmountDetails in payment.proto, but adjustment_fee_money
 * is not a repeated field since we provide aggregated views.
 *
 * SOURCE SquareProcessingFeeAmountDetails @ squareup/beemo/v2/reporting/custom_report.proto at 168:7
 */
Aggregate.Details.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails');
fixType(Aggregate.Details.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails);
Builder.createAndAttachToType(Aggregate.Details.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails);
/**
 * Details about each ThirdPartyFee assessed on this Tender.
 *
 * SOURCE ThirdPartyFeeAmountDetail @ squareup/beemo/v2/reporting/custom_report.proto at 208:7
 */
Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail');
fixType(Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail);
Builder.createAndAttachToType(Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail);
/**
 * SOURCE ThirdPartyFeeEntity @ squareup/beemo/v2/reporting/custom_report.proto at 216:7
 */
Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeEntity = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeEntity');
fixType(Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeEntity);
Builder.createAndAttachToType(Aggregate.Details.ProcessingFeeAmounts.ThirdPartyFeeEntity);
/**
 * The cost of goods data for this aggregation
 * Note (2019-02-19): The majority of these fields are actually trimmed and re-calculated in invreporter
 * because it has more data & more up-to-date calculations.
 *
 * https://git.sqcorp.co/projects/GO/repos/square/browse/invreporter/models/sale_cogs/sale_cogs_report.go?at=d5de18bc9e327359d745b6a84961102c16c1d029#81
 * As a result, it doesn't make much sense for beemo to continue to calculate and set these.
 *
 * Moving forward the only fields populated by beemo will be
 *  - total_cost_money
 *  - cogs_items_count
 * These are the aggregated, non-computed amounts purely backed by data stored in beemo with no
 * additional business logic & computations.
 *
 * Unfortunately we cannot deprecate / remove the fields that are no longer being set because
 * invreporter uses the same proto in its response and rebuilds part of the Aggregate.
 *
 * SOURCE CostOfGoodsAmounts @ squareup/beemo/v2/reporting/custom_report.proto at 257:5
 */
Aggregate.Details.CostOfGoodsAmounts = $root.lookupType('squareup.beemo.api.v2.reporting.Aggregate.Details.CostOfGoodsAmounts');
fixType(Aggregate.Details.CostOfGoodsAmounts);
Builder.createAndAttachToType(Aggregate.Details.CostOfGoodsAmounts);
/**
 * SOURCE GroupByType @ squareup/beemo/v2/reporting/custom_report.proto at 378:1
 */
export const GroupByType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByType').values;
/**
 * SOURCE GroupByValue @ squareup/beemo/v2/reporting/custom_report.proto at 567:1
 */
export const GroupByValue = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue');
fixType(GroupByValue);
Builder.createAndAttachToType(GroupByValue);
/**
 * SOURCE Discount @ squareup/beemo/v2/reporting/custom_report.proto at 573:3
 */
GroupByValue.Discount = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Discount');
fixType(GroupByValue.Discount);
Builder.createAndAttachToType(GroupByValue.Discount);
/**
 * SOURCE ItemCategory @ squareup/beemo/v2/reporting/custom_report.proto at 582:3
 */
GroupByValue.ItemCategory = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ItemCategory');
fixType(GroupByValue.ItemCategory);
Builder.createAndAttachToType(GroupByValue.ItemCategory);
/**
 * SOURCE Employee @ squareup/beemo/v2/reporting/custom_report.proto at 588:3
 */
GroupByValue.Employee = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Employee');
fixType(GroupByValue.Employee);
Builder.createAndAttachToType(GroupByValue.Employee);
/**
 * SOURCE EmployeeRole @ squareup/beemo/v2/reporting/custom_report.proto at 597:3
 */
GroupByValue.EmployeeRole = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.EmployeeRole');
fixType(GroupByValue.EmployeeRole);
Builder.createAndAttachToType(GroupByValue.EmployeeRole);
/**
 * SOURCE EmployeeJob @ squareup/beemo/v2/reporting/custom_report.proto at 604:3
 */
GroupByValue.EmployeeJob = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.EmployeeJob');
fixType(GroupByValue.EmployeeJob);
Builder.createAndAttachToType(GroupByValue.EmployeeJob);
/**
 * SOURCE Device @ squareup/beemo/v2/reporting/custom_report.proto at 611:3
 */
GroupByValue.Device = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Device');
fixType(GroupByValue.Device);
Builder.createAndAttachToType(GroupByValue.Device);
/**
 * SOURCE Item @ squareup/beemo/v2/reporting/custom_report.proto at 623:3
 */
GroupByValue.Item = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Item');
fixType(GroupByValue.Item);
Builder.createAndAttachToType(GroupByValue.Item);
/**
 * SOURCE ItemVariation @ squareup/beemo/v2/reporting/custom_report.proto at 647:3
 */
GroupByValue.ItemVariation = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ItemVariation');
fixType(GroupByValue.ItemVariation);
Builder.createAndAttachToType(GroupByValue.ItemVariation);
/**
 * SOURCE MobileStaff @ squareup/beemo/v2/reporting/custom_report.proto at 662:3
 */
GroupByValue.MobileStaff = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.MobileStaff');
fixType(GroupByValue.MobileStaff);
Builder.createAndAttachToType(GroupByValue.MobileStaff);
/**
 * SOURCE Subunit @ squareup/beemo/v2/reporting/custom_report.proto at 670:3
 */
GroupByValue.Subunit = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Subunit');
fixType(GroupByValue.Subunit);
Builder.createAndAttachToType(GroupByValue.Subunit);
/**
 * SOURCE Modifier @ squareup/beemo/v2/reporting/custom_report.proto at 677:3
 */
GroupByValue.Modifier = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Modifier');
fixType(GroupByValue.Modifier);
Builder.createAndAttachToType(GroupByValue.Modifier);
/**
 * SOURCE PaymentMethod @ squareup/beemo/v2/reporting/custom_report.proto at 687:3
 */
GroupByValue.PaymentMethod = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.PaymentMethod').values;
/**
 * SOURCE ModifierSet @ squareup/beemo/v2/reporting/custom_report.proto at 741:3
 */
GroupByValue.ModifierSet = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ModifierSet');
fixType(GroupByValue.ModifierSet);
Builder.createAndAttachToType(GroupByValue.ModifierSet);
/**
 * SOURCE TimeRange @ squareup/beemo/v2/reporting/custom_report.proto at 747:3
 */
GroupByValue.TimeRange = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TimeRange');
fixType(GroupByValue.TimeRange);
Builder.createAndAttachToType(GroupByValue.TimeRange);
/**
 * SOURCE UnitPrice @ squareup/beemo/v2/reporting/custom_report.proto at 759:3
 */
GroupByValue.UnitPrice = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.UnitPrice');
fixType(GroupByValue.UnitPrice);
Builder.createAndAttachToType(GroupByValue.UnitPrice);
/**
 * SOURCE Tax @ squareup/beemo/v2/reporting/custom_report.proto at 764:3
 */
GroupByValue.Tax = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Tax');
fixType(GroupByValue.Tax);
Builder.createAndAttachToType(GroupByValue.Tax);
/**
 * This is a ****ing huge lie -Kiran Hopefully we will change this to 'EntryMethod' or something
 * like that in the future when we can accurately report on entry methods
 *
 * SOURCE FeeType @ squareup/beemo/v2/reporting/custom_report.proto at 774:3
 */
GroupByValue.FeeType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.FeeType').values;
/**
 * Based on squareup.common.payment.Payment.SquareProduct but edited to remove BILLING, CASH etc
 *
 * SOURCE Product @ squareup/beemo/v2/reporting/custom_report.proto at 800:3
 */
GroupByValue.Product = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.Product').values;
/**
 * SOURCE Taxable @ squareup/beemo/v2/reporting/custom_report.proto at 813:3
 */
GroupByValue.Taxable = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.Taxable').values;
/**
 * SOURCE DayOfWeek @ squareup/beemo/v2/reporting/custom_report.proto at 822:3
 */
GroupByValue.DayOfWeek = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.DayOfWeek').values;
/**
 * SOURCE DiningOption @ squareup/beemo/v2/reporting/custom_report.proto at 838:3
 */
GroupByValue.DiningOption = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.DiningOption');
fixType(GroupByValue.DiningOption);
Builder.createAndAttachToType(GroupByValue.DiningOption);
/**
 * SOURCE GiftCard @ squareup/beemo/v2/reporting/custom_report.proto at 849:3
 */
GroupByValue.GiftCard = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.GiftCard');
fixType(GroupByValue.GiftCard);
Builder.createAndAttachToType(GroupByValue.GiftCard);
/**
 * SOURCE GiftCardActivityType @ squareup/beemo/v2/reporting/custom_report.proto at 855:3
 */
GroupByValue.GiftCardActivityType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.GiftCardActivityType').values;
/**
 * SOURCE CardDetails @ squareup/beemo/v2/reporting/custom_report.proto at 863:3
 */
GroupByValue.CardDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.CardDetails');
fixType(GroupByValue.CardDetails);
Builder.createAndAttachToType(GroupByValue.CardDetails);
/**
 * SOURCE VirtualRegisterDetails @ squareup/beemo/v2/reporting/custom_report.proto at 868:3
 */
GroupByValue.VirtualRegisterDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.VirtualRegisterDetails');
fixType(GroupByValue.VirtualRegisterDetails);
Builder.createAndAttachToType(GroupByValue.VirtualRegisterDetails);
/**
 * SOURCE BusinessDayDetails @ squareup/beemo/v2/reporting/custom_report.proto at 873:3
 */
GroupByValue.BusinessDayDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.BusinessDayDetails');
fixType(GroupByValue.BusinessDayDetails);
Builder.createAndAttachToType(GroupByValue.BusinessDayDetails);
/**
 * SOURCE ActivityTypeDetails @ squareup/beemo/v2/reporting/custom_report.proto at 878:3
 */
GroupByValue.ActivityTypeDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ActivityTypeDetails');
fixType(GroupByValue.ActivityTypeDetails);
Builder.createAndAttachToType(GroupByValue.ActivityTypeDetails);
/**
 * SOURCE VoidReason @ squareup/beemo/v2/reporting/custom_report.proto at 883:3
 */
GroupByValue.VoidReason = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.VoidReason');
fixType(GroupByValue.VoidReason);
Builder.createAndAttachToType(GroupByValue.VoidReason);
/**
 * SOURCE EventTypeDetails @ squareup/beemo/v2/reporting/custom_report.proto at 889:3
 */
GroupByValue.EventTypeDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.EventTypeDetails');
fixType(GroupByValue.EventTypeDetails);
Builder.createAndAttachToType(GroupByValue.EventTypeDetails);
/**
 * SOURCE DiscountAdjustmentType @ squareup/beemo/v2/reporting/custom_report.proto at 894:3
 */
GroupByValue.DiscountAdjustmentType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.DiscountAdjustmentType').values;
/**
 * SOURCE DiscountAdjustmentTypeDetails @ squareup/beemo/v2/reporting/custom_report.proto at 903:3
 */
GroupByValue.DiscountAdjustmentTypeDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.DiscountAdjustmentTypeDetails');
fixType(GroupByValue.DiscountAdjustmentTypeDetails);
Builder.createAndAttachToType(GroupByValue.DiscountAdjustmentTypeDetails);
/**
 * SOURCE CompReason @ squareup/beemo/v2/reporting/custom_report.proto at 911:3
 */
GroupByValue.CompReason = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.CompReason');
fixType(GroupByValue.CompReason);
Builder.createAndAttachToType(GroupByValue.CompReason);
/**
 * SOURCE ModifierDetails @ squareup/beemo/v2/reporting/custom_report.proto at 917:3
 */
GroupByValue.ModifierDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ModifierDetails');
fixType(GroupByValue.ModifierDetails);
Builder.createAndAttachToType(GroupByValue.ModifierDetails);
/**
 * SOURCE TaxDetails @ squareup/beemo/v2/reporting/custom_report.proto at 925:3
 */
GroupByValue.TaxDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TaxDetails');
fixType(GroupByValue.TaxDetails);
Builder.createAndAttachToType(GroupByValue.TaxDetails);
/**
 * SOURCE InclusionType @ squareup/beemo/v2/reporting/custom_report.proto at 926:5
 */
GroupByValue.TaxDetails.InclusionType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.TaxDetails.InclusionType').values;
/**
 * SOURCE DiscountDetails @ squareup/beemo/v2/reporting/custom_report.proto at 939:3
 */
GroupByValue.DiscountDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.DiscountDetails');
fixType(GroupByValue.DiscountDetails);
Builder.createAndAttachToType(GroupByValue.DiscountDetails);
/**
 * SOURCE DiscountBasisType @ squareup/beemo/v2/reporting/custom_report.proto at 940:5
 */
GroupByValue.DiscountDetails.DiscountBasisType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.DiscountDetails.DiscountBasisType').values;
/**
 * SOURCE UniqueItemization @ squareup/beemo/v2/reporting/custom_report.proto at 956:3
 */
GroupByValue.UniqueItemization = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.UniqueItemization');
fixType(GroupByValue.UniqueItemization);
Builder.createAndAttachToType(GroupByValue.UniqueItemization);
/**
 * SOURCE TicketGroup @ squareup/beemo/v2/reporting/custom_report.proto at 974:3
 */
GroupByValue.TicketGroup = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TicketGroup');
fixType(GroupByValue.TicketGroup);
Builder.createAndAttachToType(GroupByValue.TicketGroup);
/**
 * SOURCE DeviceCredential @ squareup/beemo/v2/reporting/custom_report.proto at 981:3
 */
GroupByValue.DeviceCredential = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.DeviceCredential');
fixType(GroupByValue.DeviceCredential);
Builder.createAndAttachToType(GroupByValue.DeviceCredential);
/**
 * SOURCE ItemizationNote @ squareup/beemo/v2/reporting/custom_report.proto at 996:3
 */
GroupByValue.ItemizationNote = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ItemizationNote');
fixType(GroupByValue.ItemizationNote);
Builder.createAndAttachToType(GroupByValue.ItemizationNote);
/**
 * SOURCE ReceiptDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1002:3
 */
GroupByValue.ReceiptDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ReceiptDetails');
fixType(GroupByValue.ReceiptDetails);
Builder.createAndAttachToType(GroupByValue.ReceiptDetails);
/**
 * SOURCE TicketName @ squareup/beemo/v2/reporting/custom_report.proto at 1008:3
 */
GroupByValue.TicketName = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TicketName');
fixType(GroupByValue.TicketName);
Builder.createAndAttachToType(GroupByValue.TicketName);
/**
 * SOURCE TransactionTotal @ squareup/beemo/v2/reporting/custom_report.proto at 1014:3
 */
GroupByValue.TransactionTotal = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TransactionTotal');
fixType(GroupByValue.TransactionTotal);
Builder.createAndAttachToType(GroupByValue.TransactionTotal);
/**
 * SOURCE ConversationalMode @ squareup/beemo/v2/reporting/custom_report.proto at 1024:3
 */
GroupByValue.ConversationalMode = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ConversationalMode');
fixType(GroupByValue.ConversationalMode);
Builder.createAndAttachToType(GroupByValue.ConversationalMode);
/**
 * SOURCE BillNote @ squareup/beemo/v2/reporting/custom_report.proto at 1030:3
 */
GroupByValue.BillNote = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.BillNote');
fixType(GroupByValue.BillNote);
Builder.createAndAttachToType(GroupByValue.BillNote);
/**
 * SOURCE TenderNote @ squareup/beemo/v2/reporting/custom_report.proto at 1036:3
 */
GroupByValue.TenderNote = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TenderNote');
fixType(GroupByValue.TenderNote);
Builder.createAndAttachToType(GroupByValue.TenderNote);
/**
 * SOURCE Menu @ squareup/beemo/v2/reporting/custom_report.proto at 1042:3
 */
GroupByValue.Menu = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Menu');
fixType(GroupByValue.Menu);
Builder.createAndAttachToType(GroupByValue.Menu);
/**
 * SOURCE FeePlan @ squareup/beemo/v2/reporting/custom_report.proto at 1048:3
 */
GroupByValue.FeePlan = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.FeePlan');
fixType(GroupByValue.FeePlan);
Builder.createAndAttachToType(GroupByValue.FeePlan);
/**
 * SOURCE FeePlanTypeDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1057:3
 */
GroupByValue.FeePlanTypeDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.FeePlanTypeDetails');
fixType(GroupByValue.FeePlanTypeDetails);
Builder.createAndAttachToType(GroupByValue.FeePlanTypeDetails);
/**
 * SOURCE TicketTemplate @ squareup/beemo/v2/reporting/custom_report.proto at 1063:3
 */
GroupByValue.TicketTemplate = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.TicketTemplate');
fixType(GroupByValue.TicketTemplate);
Builder.createAndAttachToType(GroupByValue.TicketTemplate);
/**
 * SOURCE RestaurantCoverDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1069:3
 */
GroupByValue.RestaurantCoverDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.RestaurantCoverDetails');
fixType(GroupByValue.RestaurantCoverDetails);
Builder.createAndAttachToType(GroupByValue.RestaurantCoverDetails);
/**
 * SOURCE CoverType @ squareup/beemo/v2/reporting/custom_report.proto at 1070:5
 */
GroupByValue.RestaurantCoverDetails.CoverType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.RestaurantCoverDetails.CoverType').values;
/**
 * SOURCE PaymentSourceName @ squareup/beemo/v2/reporting/custom_report.proto at 1082:3
 */
GroupByValue.PaymentSourceName = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.PaymentSourceName');
fixType(GroupByValue.PaymentSourceName);
Builder.createAndAttachToType(GroupByValue.PaymentSourceName);
/**
 * SOURCE ItemizationTypeDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1088:3
 */
GroupByValue.ItemizationTypeDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ItemizationTypeDetails');
fixType(GroupByValue.ItemizationTypeDetails);
Builder.createAndAttachToType(GroupByValue.ItemizationTypeDetails);
/**
 * SOURCE ItemizationType @ squareup/beemo/v2/reporting/custom_report.proto at 1090:5
 */
GroupByValue.ItemizationTypeDetails.ItemizationType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.ItemizationTypeDetails.ItemizationType').values;
/**
 * SOURCE SurchargeTypeDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1105:3
 */
GroupByValue.SurchargeTypeDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.SurchargeTypeDetails');
fixType(GroupByValue.SurchargeTypeDetails);
Builder.createAndAttachToType(GroupByValue.SurchargeTypeDetails);
/**
 * This should map one-to-one with squareup.api.items.Surcharge.Type
 *
 * SOURCE SurchargeType @ squareup/beemo/v2/reporting/custom_report.proto at 1107:5
 */
GroupByValue.SurchargeTypeDetails.SurchargeType = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.SurchargeTypeDetails.SurchargeType').values;
/**
 * SOURCE ContactDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1119:3
 */
GroupByValue.ContactDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ContactDetails');
fixType(GroupByValue.ContactDetails);
Builder.createAndAttachToType(GroupByValue.ContactDetails);
/**
 * SOURCE SurchargeNameDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1125:3
 */
GroupByValue.SurchargeNameDetails = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.SurchargeNameDetails');
fixType(GroupByValue.SurchargeNameDetails);
Builder.createAndAttachToType(GroupByValue.SurchargeNameDetails);
/**
 * SOURCE OrderSourceName @ squareup/beemo/v2/reporting/custom_report.proto at 1131:3
 */
GroupByValue.OrderSourceName = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.OrderSourceName');
fixType(GroupByValue.OrderSourceName);
Builder.createAndAttachToType(GroupByValue.OrderSourceName);
/**
 * The vendor token will be populated in coco, and then converted to a NameOrTranslationType in
 * beemoreporter.
 *
 * SOURCE Vendor @ squareup/beemo/v2/reporting/custom_report.proto at 1150:3
 */
GroupByValue.Vendor = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.Vendor');
fixType(GroupByValue.Vendor);
Builder.createAndAttachToType(GroupByValue.Vendor);
/**
 * SOURCE HouseAccountInvoice @ squareup/beemo/v2/reporting/custom_report.proto at 1159:3
 */
GroupByValue.HouseAccountInvoice = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.HouseAccountInvoice').values;
/**
 * SOURCE FreeProcessing @ squareup/beemo/v2/reporting/custom_report.proto at 1168:3
 */
GroupByValue.FreeProcessing = $root.lookupEnum('squareup.beemo.api.v2.reporting.GroupByValue.FreeProcessing').values;
/**
 * SOURCE ChannelAttribution @ squareup/beemo/v2/reporting/custom_report.proto at 1177:3
 */
GroupByValue.ChannelAttribution = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ChannelAttribution');
fixType(GroupByValue.ChannelAttribution);
Builder.createAndAttachToType(GroupByValue.ChannelAttribution);
/**
 * SOURCE ChannelReference @ squareup/beemo/v2/reporting/custom_report.proto at 1193:3
 */
GroupByValue.ChannelReference = $root.lookupType('squareup.beemo.api.v2.reporting.GroupByValue.ChannelReference');
fixType(GroupByValue.ChannelReference);
Builder.createAndAttachToType(GroupByValue.ChannelReference);
/**
 * SOURCE CustomReportRequestFlags @ squareup/beemo/v2/reporting/custom_report.proto at 1209:1
 */
export const CustomReportRequestFlags = $root.lookupType('squareup.beemo.api.v2.reporting.CustomReportRequestFlags');
fixType(CustomReportRequestFlags);
Builder.createAndAttachToType(CustomReportRequestFlags);
/**
 * Used to specify the key to group transactions by.
 * Can be a GroupByType (e.g. Category) or a ReportingGroupConfig (e.g. "Drinks")
 *
 * SOURCE GroupingType @ squareup/beemo/v2/reporting/custom_report.proto at 1287:1
 */
export const GroupingType = $root.lookupType('squareup.beemo.api.v2.reporting.GroupingType');
fixType(GroupingType);
Builder.createAndAttachToType(GroupingType);
/**
 * SOURCE CustomReportAggregateOptions @ squareup/beemo/v2/reporting/custom_report.proto at 1303:1
 */
export const CustomReportAggregateOptions = $root.lookupType('squareup.beemo.api.v2.reporting.CustomReportAggregateOptions');
fixType(CustomReportAggregateOptions);
Builder.createAndAttachToType(CustomReportAggregateOptions);
/**
 * SOURCE CustomReportRequest @ squareup/beemo/v2/reporting/custom_report.proto at 1336:1
 */
export const CustomReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.CustomReportRequest');
fixType(CustomReportRequest);
Builder.createAndAttachToType(CustomReportRequest);
/**
 * SOURCE CustomReport @ squareup/beemo/v2/reporting/custom_report.proto at 1373:1
 */
export const CustomReport = $root.lookupType('squareup.beemo.api.v2.reporting.CustomReport');
fixType(CustomReport);
Builder.createAndAttachToType(CustomReport);
/**
 * SOURCE CustomReportResponse @ squareup/beemo/v2/reporting/custom_report.proto at 1392:1
 */
export const CustomReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.CustomReportResponse');
fixType(CustomReportResponse);
Builder.createAndAttachToType(CustomReportResponse);
/**
 * Information about partial payments amounts captured within the time range.
 * Only populated if CustomReportAggregateOptions.include_partial_payment_details is set.
 *
 * outside_range_total_collected = total_collected - inside_range_total_collected.
 *
 * SOURCE PartialPaymentDetail @ squareup/beemo/v2/reporting/custom_report.proto at 1406:3
 */
CustomReportResponse.PartialPaymentDetail = $root.lookupType('squareup.beemo.api.v2.reporting.CustomReportResponse.PartialPaymentDetail');
fixType(CustomReportResponse.PartialPaymentDetail);
Builder.createAndAttachToType(CustomReportResponse.PartialPaymentDetail);
/**
 * A slim down version of GroupByValue that is flattened out.
 * Better fit for external API, and simplifies our protos.
 * This combined with a GroupByType should be able to construct a CustomReport GroupByKey
 *
 * SOURCE ReportingGroupMember @ squareup/beemo/v2/reporting/custom_report.proto at 1429:1
 */
export const ReportingGroupMember = $root.lookupType('squareup.beemo.api.v2.reporting.ReportingGroupMember');
fixType(ReportingGroupMember);
Builder.createAndAttachToType(ReportingGroupMember);
/**
 * SOURCE ReportingGroup @ squareup/beemo/v2/reporting/custom_report.proto at 1436:1
 */
export const ReportingGroup = $root.lookupType('squareup.beemo.api.v2.reporting.ReportingGroup');
fixType(ReportingGroup);
Builder.createAndAttachToType(ReportingGroup);
/**
 * SOURCE ReportingGroupConfigDetails @ squareup/beemo/v2/reporting/custom_report.proto at 1441:1
 */
export const ReportingGroupConfigDetails = $root.lookupType('squareup.beemo.api.v2.reporting.ReportingGroupConfigDetails');
fixType(ReportingGroupConfigDetails);
Builder.createAndAttachToType(ReportingGroupConfigDetails);
/**
 * Similar to a GroupByValue, but represents ReportingGroups instead.
 *
 * SOURCE ReportingGroupValue @ squareup/beemo/v2/reporting/custom_report.proto at 1447:1
 */
export const ReportingGroupValue = $root.lookupType('squareup.beemo.api.v2.reporting.ReportingGroupValue');
fixType(ReportingGroupValue);
Builder.createAndAttachToType(ReportingGroupValue);
/**
 * SOURCE AvailableFiltersRequest @ squareup/beemo/v2/reporting/custom_report.proto at 1451:1
 */
export const AvailableFiltersRequest = $root.lookupType('squareup.beemo.api.v2.reporting.AvailableFiltersRequest');
fixType(AvailableFiltersRequest);
Builder.createAndAttachToType(AvailableFiltersRequest);
/**
 * SOURCE AvailableFiltersResponse @ squareup/beemo/v2/reporting/custom_report.proto at 1476:1
 */
export const AvailableFiltersResponse = $root.lookupType('squareup.beemo.api.v2.reporting.AvailableFiltersResponse');
fixType(AvailableFiltersResponse);
Builder.createAndAttachToType(AvailableFiltersResponse);
/**
 * Options used to determine what data to fetch when generating Custom Reports that include Live Data.
 *
 * SOURCE LiveDataOptions @ squareup/beemo/v2/reporting/custom_report.proto at 1482:1
 */
export const LiveDataOptions = $root.lookupType('squareup.beemo.api.v2.reporting.LiveDataOptions');
fixType(LiveDataOptions);
Builder.createAndAttachToType(LiveDataOptions);
/**
 * SOURCE Filter @ squareup/beemo/v2/reporting/custom_report.proto at 1487:1
 */
export const Filter = $root.lookupType('squareup.beemo.api.v2.reporting.Filter');
fixType(Filter);
Builder.createAndAttachToType(Filter);
/**
 * SOURCE FilterMode @ squareup/beemo/v2/reporting/custom_report.proto at 1496:3
 */
Filter.FilterMode = $root.lookupEnum('squareup.beemo.api.v2.reporting.Filter.FilterMode').values;
/**
 * SOURCE FilterV2 @ squareup/beemo/v2/reporting/custom_report.proto at 1517:1
 */
export const FilterV2 = $root.lookupType('squareup.beemo.api.v2.reporting.FilterV2');
fixType(FilterV2);
Builder.createAndAttachToType(FilterV2);
/**
 * SOURCE AnyTerm @ squareup/beemo/v2/reporting/custom_report.proto at 1524:1
 */
export const AnyTerm = $root.lookupType('squareup.beemo.api.v2.reporting.AnyTerm');
fixType(AnyTerm);
Builder.createAndAttachToType(AnyTerm);
/**
 * SOURCE MatchStrategy @ squareup/beemo/v2/reporting/custom_report.proto at 1531:3
 */
AnyTerm.MatchStrategy = $root.lookupEnum('squareup.beemo.api.v2.reporting.AnyTerm.MatchStrategy').values;
/**
 * SOURCE FilterMode @ squareup/beemo/v2/reporting/custom_report.proto at 1539:3
 */
AnyTerm.FilterMode = $root.lookupEnum('squareup.beemo.api.v2.reporting.AnyTerm.FilterMode').values;
/**
 * SOURCE MeasuredQuantity @ squareup/beemo/v2/reporting/custom_report.proto at 1553:1
 */
export const MeasuredQuantity = $root.lookupType('squareup.beemo.api.v2.reporting.MeasuredQuantity');
fixType(MeasuredQuantity);
Builder.createAndAttachToType(MeasuredQuantity);